(function (factory) {
    var undef = 'undefined';
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (require, exports, module ) {
            return factory(
                root, 
                require('./lib/SwitchBoard'),
                require('./lib/Topic'),
                require('./lib/ChannelBroker')
            );
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            root, 
            require('./lib/SwitchBoard'),
            require('./lib/Topic'),
            require('./lib/ChannelBroker')
        );
    } else {
        root.MessageService = factory(
            root, 
            root.MessageServiceSwitchBoard,
            root.MessageServiceTopic,
            root.MessageServiceChannelBroker 
        );
    }
})(function(globalChannel, Switchboard, Topic, ChannelBroker){
    var ALL_TOPICS = '*';

    function getTargetContext (target) {
        var targetContext;
        if (target && target.postMessage) {
            targetContext = target;
        } else if (target instanceof Node) {
            targetContext = target.window || target.contentWindow;
        }
        return targetContext;

    }
    function MessageService (bindTo) {
        var messageService = this;
        var rebind = bindTo || this;

        if(bindTo){
            var method;
            for( method in _proto_){
                bindTo[method]=this[method].bind(messageService);
            }
        }

        var switchboard = this.switchboard = new Switchboard();
        var hub = this.hub = switchboard.port1;
        var dock = this.dock = switchboard.port2;
        var hub = this.hub;
        var topics = this.topics = {};
        var specialRepeater = new Switchboard().port1;

        var allTopicsRepeater = this.allTopicsRepeater = new Topic(ALL_TOPICS, specialRepeater);
  
        function allTopicsListener(msg, evt){
            Topic.publishTopic(topics[ALL_TOPICS], msg, evt.originalType);
        }

        allTopicsRepeater.addConsumer(this, allTopicsListener, false, {});

        this.channelBroker = new ChannelBroker(this.dock, this);

        // Adding/removing listeners requires special scoping
        // Best to just apply these to the instance to support binding to 
        // custom objects
        rebind.on = rebind.addListener =  function (topicName, callback ) {
            Topic.addTopicListener(this, hub, topics, topicName, callback, false);
        };
            
        rebind.off = rebind.removeListener = function (topicName, callback) {
            Topic.removeTopicListener(this, topics, topicName, callback);
        };

        rebind.one = rebind.once = function(topicName, callback) {
            Topic.addTopicListener(this, hub, topics, topicName, callback, true);
        };
    }

    var _proto_ = MessageService.prototype = {

        publish: function (topicName, msg, localOnly) {
            var result = Topic.publishTopic(this.topics[topicName], msg);

            Topic.publishTopic(this.allTopicsRepeater, msg, topicName);

            if(localOnly!==true){
                this.channelBroker.publish(topicName, msg)
            }
            return result;
        },

        publishChannel: function (topicName, msg) {
            return this.channelBroker.publish(topicName, msg);
        },
            
        removeAllListeners: function (topicName) {
            var topic;
            var topics = this.topics;
            if (topicName) {
                Topic.removeAllTopicListeners(topics, topicName);
            } else {
                for (topic in topics) {
                    Topic.removeAllTopicListeners(topics, topic);
                }
            }
        },

        getTopics: function (topicName) {
            return this.topics;
        },

        hasListeners: function (topicName) {
            var topic = this.topics[topicName];
 
            if (topicName && topic) {
                return !!topic.consumerCount;
            }
            return false;
        },

        openChannel: function (target, _id, initData) {
            var targetContext = getTargetContext(target);
            var id = _id || "global";

            if (targetContext && targetContext.postMessage) {
                return this.channelBroker.connect(targetContext, id, initData);
            }
            return false;
        },

        closeChannel: function (target, _id) {
            var targetContext = getTargetContext(target);
            var id = _id || "global";

            if (targetContext && targetContext.postMessage) {
                this.channelBroker.disconnect(targetContext, id);
                return true;
            }
            return false;
        }
    };

    /**
     * Generate the MessageService api and bind it to object obj.
     * Limit the scope of operation to the DOM element target. (Defaults to window)
     * @param  {mixed}  [obj]   Any object decendent of Object to apply
     *                          the MessageService api.
     * @return {mixed}          obj is returned after binding operation is complete
     */
    var create = function (obj) {

        var messageService = new MessageService(obj);
        messageService.sharedMessageService = sharedMessageService;
        return obj || messageService;
    };
    /**
     * Generate the MessageService api for "global" operations
     * @see  bind
     */
    var sharedMessageService = create();

    sharedMessageService.sharedMessageService = sharedMessageService;

    sharedMessageService.bind = function (obj) {
        if(!obj){
            throw new Error("Binding object not specified");
            return;
        }
        return create(obj);
    };
    sharedMessageService.create = create;
    return sharedMessageService;
});
